<template>
  <div>
    <v-text-field
      hide-details
      :label="label ?  label : 'Url' "
      :value="value"
      append-outer-icon="fa-upload"
      @click:append-outer="selectFile"
      :loading="uploading"
      :dark="dark"
    >
      <template v-slot:progress>
        <v-progress-circular
          color="green"
          :indeterminate="upload_progress>=100 && uploading"
          :value="upload_progress"
        ></v-progress-circular>
      </template>
    </v-text-field>

    <input
      type="file"
      style="display:none"
      ref="input"
      @change="handleFileChange($event)"
      :accept="accept"
    />
  </div>
</template>
<script>
import Axios from "axios";

export default {
  name: "",
  props: ["value", "label", "accept", "dark"],
  data: () => ({
    uploading: false,
    upload_progress: 0,
    random_id: Math.round(Math.random() * 100000)
  }),
  computed: {},
  methods: {
    selectFile() {
      this.$refs["input"].click();
    },
    async uploadFile(file) {
      this.uploading = true;
      try {
        this.upload_progress = 0;
        let upload_url = await this.$api({
          method: "POST",
          url: `/account/upload-url`,
          data: {
            file: {
              name: file.name,
              size: file.size,
              type: file.type
            },
            key: `images/random-${Math.round(Math.random() * 100)}`
          }
        });
        var upload_options = {
          headers: {
            "Content-Type": file.type,
            "x-amz-acl": "public-read"
          },
          Metadata: {
            "Content-Disposition": "attachment"
          },
          onUploadProgress: function(progressEvent) {
            console.log(progressEvent);
            this.upload_progress = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this)
        };
        await Axios.put(upload_url, file, upload_options);
        this.$emit("input", upload_url.split("?")[0]);
        this.$emit("change", this.value);
      } catch (ex) {
        alert("Upload failed");
      }
      this.uploading = false;
    },

    handleFileChange: function(ev) {
      this.$emit("input", null);
      //validate then upload.
      ev.preventDefault();
      let file;
      if (ev.target.files) {
        file = ev.target.files[0];
      }

      if (file) {
        this.uploadFile(file);
      }
      this.$refs["input"].value = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.addbox {
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}
</style>
